import { graphql } from "babel-plugin-relay/macro";

export const deleteCardQL = graphql`
  mutation deleteCardMutation($id: ID!, $loopFilter: LoopFilter) {
    deleteCard(id: $id) {
      ...loopQuery_loop @arguments(loopFilter: $loopFilter)
    }
  }
`;
